export const GAME_INTENSITIES = {
  casual: {
    id: "casual",
    label: "Casual",
    description: "Relaxed, social gaming",
  },
  moderate: {
    id: "moderate",
    label: "Moderate",
    description: "Competitive but friendly",
  },
  competitive: {
    id: "competitive",
    label: "Competitive",
    description: "Serious gameplay",
  },
} as const

export const GAME_GENRES = {
  strategy: {
    id: "strategy",
    label: "Strategy",
    description: "Board games, card games, etc.",
  },
  party: {
    id: "party",
    label: "Party Games",
    description: "Social games, trivia, etc.",
  },
  rpg: {
    id: "rpg",
    label: "Role-Playing Games",
    description: "D&D, storytelling games",
  },
  word: {
    id: "word",
    label: "Word Games",
    description: "Scrabble, word search, etc.",
  },
} as const
